export { default } from './VoteNewCollectionContainer';
